import {inject, Injectable} from '@angular/core';
import {ConfigurationLoader} from '../core/configuration/services/configuration.loader';
import {UserData} from '../core/user/models/user-data';
import {UserService} from '../core/user/services/user.service';
import {ThinClientModeService} from '../services/thin-client-mode.service';

@Injectable({
  providedIn: 'root'
})
export class AirParamService {
  private readonly configurationLoader = inject(ConfigurationLoader);
  private readonly userService = inject(UserService);


  static convertMileageUnitForAir(awpMileageUnit: string): string {
    switch (awpMileageUnit) {
      case 'km':
        return 'K';
      case 'mi':
        return 'M';
      default:
        return 'K';
    }
  }

  private static addParamIfAbsent(params: any, key: string, value: string | boolean): void {
    if (!params[key]) {
      Object.assign(params, {[key]: value});
    }
  }

  private static getAirMileageUnit(user: UserData): string {
    if (user?.getMileageUnit() === 'mi') {
      return 'MILE';
    } else {
      return 'KILOMETER';
    }
  }

  private static getAirRoles(isDcomConfigured: boolean,
                             isDmsWriteAccessAllowed: boolean,
                             isDmsLicensePlateSearchAllowed: boolean): string {
    const airRoles: string[] = [];
    if (isDmsWriteAccessAllowed) {
      airRoles.push('R32');
    }
    if (isDcomConfigured) {
      airRoles.push('R33');
    }
    if (isDmsLicensePlateSearchAllowed) {
      airRoles.push('R36');
    }

    return airRoles.join(',');
  }

  addMandatoryAirParams(airParams: any): void {
    const user: UserData = this.userService.getCurrentUser();
    AirParamService.addParamIfAbsent(airParams, 'LANGUAGE', user?.getLocale());
    AirParamService.addParamIfAbsent(airParams, 'CALLING_APPLICATION', 'AFTERSALES_WORKPLACE');
    AirParamService.addParamIfAbsent(airParams, 'DISTANCE_UNIT', AirParamService.getAirMileageUnit(user));
    if (ThinClientModeService.thinClientMode) {
      AirParamService.addParamIfAbsent(airParams, 'PROFILE', 'AWPCLIENT');
    } else {
      AirParamService.addParamIfAbsent(airParams, 'PROFILE', 'AWP');
    }
    if (user) {
      AirParamService.addParamIfAbsent(
        airParams,
        'VPNR',
        user.getBusinessPartner()?.getDistributionPartnerNumber()
      );
      AirParamService.addParamIfAbsent(airParams, 'OUTLET', user.getBusinessPartner()?.getOutletNumber());
      this.applyOutletConfigToAirParams(airParams);
    }
  }

  private applyOutletConfigToAirParams(airParams: any): void {
    AirParamService.addParamIfAbsent(airParams, 'ALLOW_FRU_VALUE', this.configurationLoader.showFlatRateUnitValues());
    AirParamService.addParamIfAbsent(airParams, 'ALLOW_GDPR', this.configurationLoader.isGdprEnabled());
    AirParamService.addParamIfAbsent(
      airParams,
      'ALLOW_SERVICE_HISTORY_DELETION',
      this.configurationLoader.isServiceHistoryDeletionAllowed()
    );
    if (ThinClientModeService.thinClientMode) {
      AirParamService.addParamIfAbsent(airParams, 'ROLES', AirParamService.getAirRoles(
        this.configurationLoader.isDcomConfigured(),
        this.configurationLoader.isDmsWriteAccessAllowed(),
        this.configurationLoader.isDmsLicensePlateSearchAllowed()
      ));
    }
  }
}
